import React, { useEffect, useState } from 'react';
import InputField from '../../ReusableComponents/InputField';
import { Button } from '../../Components/Helper';
import { nameValidation } from '../../utils/inputValidations';
import Modal from '../../ReusableComponents/Modal';
import Form from '../../ReusableComponents/Form';
import TextAreaField from '../../ReusableComponents/textAreaField';
import { getCropDetails } from '../../apis/adminAPIs/crops';
import LoaderComponent from '../../ReusableComponents/LoaderComponent';

const AddCrop = ({ open, onClose, crop, onCropAdd }) => {
    const [loading, setLoading] = useState(false)
    const [cropDetails, setCropDetails] = useState({
        Hindi: "",
        Marathi: "",
        Punjabi: "",
        Kannada: "",
        Gujarati: "",
        Tamil: "",
        Telugu: "",
        English: "",
        Malayalam: ""
    })

    const [error, setError] = useState({
        Hindi: "",
        Marathi: "",
        Punjabi: "",
        Kannada: "",
        Gujarati: "",
        Tamil: "",
        Telugu: "",
        English: "",
        Malayalam: ""
    })

    const isEveryFieldFill = () => {
        for (const key in cropDetails) {
            const value = cropDetails[key];
            if (!value) {
                return false; 
            } 
        }
        for (const key in error) {
            if (error[key]) {
                return false;
            }
        }
        return true;
    };
    
    const handleInputChange = (name, value) => {
        setCropDetails((prev) => ({
            ...prev,
            [name]: value,
        }))
        
        if (value?.length <2 && value !== "") {
            setError((prev) => ({
                ...prev,
                [name]: `crop name must be at least 2 characters long.`
            }));
        } else if (value?.length >= 2) {
            setError((prev) => ({
                ...prev,
                [name]: ""
            }));
        } else if (value === "") {
            setError((prev) => ({
                ...prev,
                [name]: ""
            }));
        }
    }


    const getCropDetailsFunc=async(cropId)=>{
        try{
           setLoading(true);
           let {cropDetails}=await getCropDetails(cropId);
           setCropDetails(cropDetails);
           setLoading(false);
        }catch(err){
            setLoading(false);
           console.log("err",err);
        }
    }

    useEffect(()=>{
        if(crop?.id){
            getCropDetailsFunc(crop?.id);
        }
    },[crop?.id])
      

    return (
        <Modal
            header={crop?.id ? "Update Crop" : "Add Crop"}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "730px", height: "auto" }}
            style={{ display: 'flex',width:"600px", alignItems: 'center', justifyContent: 'center' }}
        >
            {loading ? <div className='min-h-[250px]'>
                <LoaderComponent width={"5%"} height={"5%"}/>
            </div> : <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '100%' }}>
                <Form
                    onSubmitForm={(data) => {   
                        onCropAdd(data);
                    }}
                    initialValues={cropDetails || {
                        Hindi: "",
                        Marathi: "",
                        Punjabi: "",
                        Kannada: "",
                        Gujarati: "",
                        Tamil: "",
                        Telugu: "",
                        English: "",
                        Malayalam: ""
                    }}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: "11px",
                        gap: "50px"
                    }}
                >
                    {(onsubmit) => (
                        <>
                        
                        <div style={{ display: "grid",gridTemplateColumns:"repeat(3, 1fr)" , rowGap:"5px",columnGap:"15px" }}>
                        {/* English */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"English"}
                                type={"text"}
                                id={"English"}
                                placeholder={"Enter crop in english"}
                                name={"English"}
                                handleChange={(data)=>handleInputChange("English",data)}
                            />
                            {error.English && <span className='text-red-500 -mt-3 '>{error.English}</span>}
                        </div>
                        
                        {/* Marathi */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"Marathi"}
                                type={"text"}
                                id={"Marathi"}
                                placeholder={"Enter crop in marathi"}
                                name={"Marathi"}
                                handleChange={(data)=>handleInputChange("Marathi",data)}
                            />
                            {error.Marathi && <span className='text-red-500 -mt-3 '>{error.Marathi}</span>}
                        </div>
                        
                        {/* Hindi */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"Hindi"}
                                type={"text"}
                                id={"Hindi"}
                                placeholder={"Enter crop in hindi"}
                                name={"Hindi"}
                                handleChange={(data)=>handleInputChange("Hindi",data)}
                            />
                            {error.Hindi && <span className='text-red-500 -mt-3 '>{error.Hindi}</span>}
                        </div>
                        
                        {/* Gujarati */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"Gujarati"}
                                type={"text"}
                                id={"Gujarati"}
                                placeholder={"Enter crop in gujarati"}
                                name={"Gujarati"}
                                handleChange={(data)=>handleInputChange("Gujarati",data)}
                            />
                            {error.Gujarati && <span className='text-red-500 -mt-3 '>{error.Gujarati}</span>}
                        </div>
                        
                        {/* Punjabi */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"Punjabi"}
                                type={"text"}
                                id={"Punjabi"}
                                placeholder={"Enter crop in punjabi"}
                                name={"Punjabi"}
                                handleChange={(data)=>handleInputChange("Punjabi",data)}
                            />
                            {error.Punjabi && <span className='text-red-500 -mt-3 '>{error.Punjabi}</span>}
                        </div>
                        
                        {/* Kannada */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"Kannada"}
                                type={"text"}
                                id={"Kannada"}
                                placeholder={"Enter crop in kannada"}
                                name={"Kannada"}
                                handleChange={(data)=>handleInputChange("Kannada",data)}
                            />
                            {error.Kannada && <span className='text-red-500 -mt-3 '>{error.Kannada}</span>}
                        </div>
                        
                        {/* Tamil */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"Tamil"}
                                type={"text"}
                                id={"Tamil"}
                                placeholder={"Enter crop in tamil"}
                                name={"Tamil"}
                                handleChange={(data)=>handleInputChange("Tamil",data)}
                            />
                            {error.Tamil && <span className='text-red-500 -mt-3 '>{error.Tamil}</span>}
                        </div>
                        
                        {/* Telugu */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"Telugu"}
                                type={"text"}
                                id={"Telugu"}
                                placeholder={"Enter crop in telugu"}
                                name={"Telugu"}
                                handleChange={(data)=>handleInputChange("Telugu",data)}
                            />
                            {error.Telugu && <span className='text-red-500 -mt-3 '>{error.Telugu}</span>}
                        </div>
                        
                        {/* Malayalam */}
                        <div className='flex flex-col'>
                            <InputField
                                defaultValue={crop?.name}
                                label={"Malayalam"}
                                type={"text"}
                                id={"Malayalam"}
                                placeholder={"Enter crop in Malayalam"}
                                name={"Malayalam"}
                                handleChange={(data)=>handleInputChange("Malayalam",data)}
                            />
                            {error.Malayalam && <span className='text-red-500 -mt-3 '>{error.Malayalam}</span>}
                        </div>
                    </div>
                        
                            
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row-reverse",
                                    padding: "10px 0px 15px 15px",
                                    gap: "20px"
                                }}
                            >
                                <Button
                                    text={crop?.id ? "Update" : "Add"}
                                    onClick={onsubmit}
                                    isDisabled={!isEveryFieldFill()}
                                    style={{ width: "90px" }}
                                />
                                <Button
                                    text={"Cancel"}
                                    onClick={onClose}
                                    isBtnNotActive={true}
                                    style={{ width: "90px" }}
                                />
                            </div>
                        </>
                    )}
                </Form>
            </div>}
        </Modal>
    );
}

export default AddCrop;